export default __webpack_public_path__ + "static/logo-romax-4000-3928e76a3503ad36861feaa67429fbd3.svg";